const camelToSnake = (string) => {
  if (!string) return ''

  return string
    .replace(/[\w]([A-Z])/g, function (m) {
      return m[0] + '_' + m[1]
    })
    .toLowerCase()
}

export default camelToSnake
